<template>
  <SharedLink
    :link="link"
  >
    <NuxtImg
      v-if="img"
      class="inline"
      :class="{ 'rounded-md': roundedBorder, 'shadow-base': shadow }"
      :style="{ width }"
      :src="img.src"
      sizes="lg:100vw 48vw"
      :srcset="img.srcSet"
      :title="img.title ?? img.alt"
      :alt="img.alt"
      :loading="mgnlProps.imageLoadType"
      :preload="mgnlProps.imageLoadType === 'eager'"
      :fetchpriority="mgnlProps.imageLoadType === 'eager' ? 'high' : 'low'"
    />
    <KikLegalInformationDrawer
      v-if="enableLegalDisclaimer"
      :legal-text="mgnlProps.legalText ?? ''"
      :title="mgnlProps.legalTitle ?? ''"
    />
  </SharedLink>
</template>

<script lang="ts" setup>
import magnoliaGetters from '~/composables/getters/magnoliaGetters';
import { ImageBuilder, WrapperProps } from '~/components/Shared/MagnoliaElements/Image/Image.model';

const props = defineProps(WrapperProps);
const mgnlProps = ImageBuilder.build(props);
const roundedBorder = inject('roundedBorder', false);
const shadow = inject('shadow', false);
const { $domain } = useNuxtApp();

const width = `${mgnlProps.width}px`;
const img = computed(() => ({
  title: magnoliaGetters.getTitleImage(mgnlProps.image, mgnlProps.title),
  alt: magnoliaGetters.getAltImage(mgnlProps.image, mgnlProps.alt),
  src: magnoliaGetters.getDefaultSrcAsset(mgnlProps.image, $domain.cmsAssetDomainPath),
  srcSet: magnoliaGetters.getSrcSetImagesAsString(mgnlProps.image, $domain.cmsAssetDomainPath, mgnlProps.aspectRatio, mgnlProps.mobileAspectRatio?.[0]?.aspectRatio),
}));

const link = computed(() => magnoliaGetters.getLinkAndName({
  switchable: mgnlProps.switchable,
  linkTargetMode: mgnlProps.linkTargetMode,
  metadata: mgnlProps.metadata,
  title: mgnlProps.title,
}, $domain.cmsAssetDomainPath,
mgnlProps.switchable?.intLinkParam,
));
</script>
